import i18n from '@/i18n';
import moment from 'moment';

export const differYear = (
  startDate,
  endDate,
  precision = false,
  diffFormat = 'day'
) => {
  if (!startDate || !endDate) return 0; // 未填寫開始/結束日期處理
  return moment(endDate).diff(moment(startDate), diffFormat, precision);
};
export const getNowTime = (format = 'YYYY/MM/DD') => {
  // 獲取當前時間
  return moment(new Date()).format(format);
};

export const dayFormat = function (value, format = 'YYYY-MM-DD') {
  // 日期格式化
  if (!value) return;
  return moment(value).format(format);
};

//判斷是否是手機端(APP、移動端)
export const is_mobile = function () {
  // 判斷是否手機端
  var is_mobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent
    );
  return is_mobile;
};

export const getSpan = function () {
  if (is_mobile()) {
    return 24;
  }
  return 12;
};

export const ApiLanguage = function () {
  const language =
    ['ZH_HANT', 'PT', 'EN'][['zh-TW', 'pt', 'en'].indexOf(i18n.locale)] ||
    'ZH_HANT';
  return language;
};

export const isZHHANT = function () {
  if (i18n.locale.toUpperCase() === 'ZH-HANT') {
    return true;
  }
  return false;
};

export const downloadFile = function (res, name) {
  // 下載文件
  // let blobData = new Blob([res.data]);
  let blobData = res;
  let fileName = res?.headers
    ? res?.headers['content-disposition'].split(';')[1].split('=')[1]
    : name;
  fileName = fileName ? decodeURI(fileName) : '.pdf';
  let elink = document.createElement('a');
  elink.download = fileName;
  elink.style.display = 'none';
  elink.href = URL.createObjectURL(blobData);
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href);
  document.body.removeChild(elink);
};

export function getCompanyType(type) {
  if (type === 'PERSONAL') {
    return i18n.t('Common.title.business');
  } else if (type === 'COMPANY') {
    return i18n.t('Common.title.company');
  }
  return '';
}

export function getResultTip(status, companyType) {
  let str = i18n.t('apply.message.resultTip');
  if (status === 'PASSED' && companyType === 'PERSONAL') {
    str = i18n.t('apply.message.businessResultTip');
  } else if (status === 'PASSED' && companyType === 'COMPANY') {
    str = i18n.t('apply.message.companyResultTip');
  }
  return str;
}

export function disabledDate(current) {
  if (!current) return false; // 如果沒有日期，不禁用

  const today = new Date();
  today.setHours(0, 0, 0, 0); // 今天的 00:00:00

  const tenDaysLater = new Date();
  tenDaysLater.setDate(today.getDate() + 10);
  tenDaysLater.setHours(0, 0, 0, 0); // 10 天後的 00:00:00

  // 只允許選擇 10 天後的日期（禁用今天到 10 天內的日期）
  return current < tenDaysLater;
}

export const mobileNum = function () {
  return /^6\d{7}$/;
};

export const mobileNum86 = function () {
  return /^1[3-9]\d{9}$/;
};

export const hkMobile = function () {
  return /^[2356789]\d{7}$/;
};

export const phoneFormat = function (value) {
  if (value === '+86') {
    return mobileNum86();
  } else if (value === '+853') {
    return mobileNum();
  } else if (value === '+852') {
    return hkMobile();
  }
  return '';
};

// 匹配澳门、香港、大陆的区号（返回区号和剩余号码）
export const parsePhoneNumber = function (phone) {
  const patterns = [
    // 澳门（853）
    { regex: /^(?:\+?853|\(853\)|00853)[\s-]?(\d{8})$/i, areaCode: '+853' },
    // 香港（852）
    { regex: /^(?:\+?852|\(852\)|00852)[\s-]?(\d{8})$/i, areaCode: '+852' },
    // 大陆（86）
    { regex: /^(?:\+?86|\(86\)|0086)[\s-]?(\d{11})$/i, areaCode: '+86' },
  ];

  for (const pattern of patterns) {
    const match = phone.match(pattern.regex);
    if (match) {
      return {
        areaCode: pattern.areaCode,
        phone: match[1], // 提取区号后的号码部分
      };
    }
  }
  // 无区号的纯数字（如 66666666）
  if (/^\d+$/.test(phone)) {
    return {
      areaCode: '+853',
      phone: null,
    }; // 不回填
  }

  // 其他无效格式
  return {
    areaCode: '+853',
    phone: null,
  }; // 不回填
};

export const getIdCardType = function (value) {
  let str = '';
  if (value === '8') {
    str = i18n.t('certificateType.CHINESE_PASSPORT');
  } else if (value === '9') {
    str = i18n.t('certificateType.HONG_KONG_ID_CARD');
  } else if (value === '12') {
    str = i18n.t('certificateType.PASSPORT_OR_TRAVEL_DOCUMENT');
  } else if (value === '14') {
    str = i18n.t('certificateType.MACAU_NON_PERMANENT_RESIDENT_ID_CARD');
  } else if (value === '15') {
    str = i18n.t('certificateType.MACAU_PERMANENT_RESIDENT_ID_CARD');
  } else if (value === '19') {
    str = i18n.t('certificateType.FOREIGN_EMPLOYEE_IDENTITY_CARD');
  } else if (value === '20') {
    str = i18n.t('certificateType.CHINESE_RESIDENT_ID_CARD');
  } else if (value === '21') {
    str = i18n.t('certificateType.OFFICIAL_TRAVEL_TO_HK_MACAU_PERMIT');
  } else if (value === '22') {
    str = i18n.t('certificateType.TRAVEL_TO_HK_MACAU_PERMIT');
  } else if (value === '23') {
    str = i18n.t('certificateType.SPECIAL_STAY_PERMIT');
  } else if (value === 'commercialCode') {
    str = i18n.t('certificateType.COMMERCIAL_CODE');
  } else if (value === 'organizationCode') {
    str = i18n.t('certificateType.ORGANIZATION_CODE');
  }
  return str;
};

export const formatAreaCode = function (areaCode) {
  if (!areaCode) return '';
  // 去除首尾空格
  const trimmedCode = areaCode.trim();
  // 已有+号直接返回
  if (trimmedCode.startsWith('+')) {
    return trimmedCode;
  }
  // 补充+号并返回
  return `+${trimmedCode}`;
};

export const getMatterConfirmStatus = function (item) {
  if (item.status === 'IDENTITY') {
    return true;
  } else if (
    item.status === 'CLOSED' &&
    item.multipleConfirm &&
    item.syncMultiConfirmation
  ) {
    return true;
  }
  return false;
};

export const getInitMatterConfirmStatus = function (item, profile) {
  if (
    item.accountId === profile?.euid &&
    item?.status === 'IDENTITY' &&
    item?.multipleConfirm &&
    item?.multipleConfirmRedirectUri &&
    !item?.syncMultiConfirmation
  ) {
    return true;
  }
  return false;
};

//證件編碼
export const idCardFormat = function (s) {
  if (!s) return
  let str = ''
  for (let i = 0; i < s.length - 4; i++) {
    str = str + '*'
  }
  return s.substring(0, 4) + str
}
